export default __webpack_public_path__ + "static/media/LittleDragonCh4.606fb57b.svg";